var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1333.333 1333.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-787.08 500h1000V-500h-1000Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-135.54-116.556h429.032v429.031H-135.54Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-135.548-89.936h429.031v429.03h-429.03Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-143.686-150.171h429.03v429.03h-429.03Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-76.909-123.072h429.031V305.96h-429.03Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-70.368-106.788h429.031v429.031h-429.03Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-309.112-232.728H119.92v429.03h-429.03Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-121.172-211.286H307.86v429.031h-429.03Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-395.575-311.09H33.456v429.032h-429.03Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-158.55-128.53-287.079-287.079-287.079-158.55 0-287.08 128.529-287.08 287.079s128.53 287.079 287.08 287.079S0 158.55 0 0",
    clipPath: "url(#a)",
    style: {
      fill: "#e0a800",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#002566",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 1049.44 666.667)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-22.18 1283.157 -1140.371)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2364px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "O")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-11.458 2173.964 -2697.804)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2365px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "R")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-4.363 5150.055 -8121.84)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2363px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(3.027 -6588.698 12534.193)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2368px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "O")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(13.669 -1181.598 3148.688)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2367px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "N")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(20.815 -658.817 2268.737)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2365px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(24.788 -494.99 1975.324)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2367px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(70.69 -375.986 606.563)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "C")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(64.447 -474.1 675.412)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(58.916 -562.374 725.337)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9998px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(51.014 -728.02 828.3)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(45.406 -885.706 939.594)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(39.693 -1072.735 1043.044)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(31.1 -1495.333 1310.725)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "P")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(22.795 -2195.31 1749.993)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "E")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(14.45 -3694.107 2689.843)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "X")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(8.552 -6510.364 4544.028)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(3.066 -18788.246 12199.97)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0001px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "F")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-4.397 13683.902 -8252.864)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "L")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-9.903 6248.975 -3638.756)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-16.494 3880.214 -2050.918)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0001px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "G")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-25.869 2576.046 -1240.73)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9997px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "H")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-34.15 2011.43 -894.959)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-39.64 1759.152 -756.39)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0001px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-45.117 1576.795 -621.847)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-53 1372.039 -490.602)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "E")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-61.607 1204.872 -383.396)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-71.315 1061.864 -289.518)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9997px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "M")), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.027.316 2.294.245 3.204-.392 2.102-1.663-.843-7.579-1.856-9.653-5.545-11.353-15.649-14.411-25.256-20.906-7.519-5.084-7.623-11.922-10.967-19.448-1.085-2.442-3.965-8.941-7.648-6.033-2.75 2.171.793 5.529 1.517 7.277 2.469 5.96 3.841 12.997 7.806 18.262 6.072 8.063 20.32 11.186 26.754 19.953C-4.909-8.845-1.523-.468 0 0",
    clipPath: "url(#b)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 583.901 783.17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.138.64 3.963-.256 4.23-2.536.342-2.925-9.352-15.262-10.852-19.633-1.54-4.488-.977-9.709-3.236-14.144-1.144-2.247-3.825-4.81-5.974-2.106-1.706 2.147.254 3.673.753 5.698 1.1 4.461 1.201 9.085 2.875 13.418C-10.83-15.743-4.31-5.177-1.925-1.884-1.431-1.202-.855-.256 0 0",
    clipPath: "url(#c)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 583.913 818.663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.083-2.579-1.603-12.401-2.998-15.417-.849-1.836-1.351-3.687-3.711-3.809-6.56-.34.25 11.278 1.205 14.461.512 1.709-.075 5.832 2.706 6.037C-2.085 1.325-.417.516 0 0",
    clipPath: "url(#d)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 594.764 738.349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.18.647 4.904-3.371 7.234-5.023 2.012-1.426 7.049-2.28 6.247-5.474-1.55-6.177-11.606.858-13.896 3.798C-2.058-4.589-3.567-.726 0 0",
    clipPath: "url(#e)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 505.728 774.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.067.933 4.019-3.829 6.394-5.897 1.824-1.588 8.495-3.933 4.61-7.294C6.107-17.429-7.086-2.157 0 0",
    clipPath: "url(#f)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 497.006 796.193)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.362 1.431 4.883 3.439 6.909 5.303 1.85 1.703 8.406 10.65 10.583 6.257 1.551-3.131-3.976-7.393-6.238-9.515C9.42.324 3.963-4.791 1.732-4.779-.99-4.764-1.304-1.91 0 0",
    clipPath: "url(#g)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 815.332 628.273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.505.45-.715 2.263-.883 3.053-.936 4.398-2.308 13.34-2.526 17.703-.074 1.484-.25 5.203 1.097 6.002.933.553 2.698.452 3.589-.228C3.59 24.763 3.96 6.526 5.202 2.845 5.51.036 1.886-1.68 0 0",
    clipPath: "url(#h)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 564.745 656.863)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .009 9.783c-.74 1.467-7.257 2.762-8.422 4.609l28.239 6.238zm-47.131-28.407c.181-.145 1.31-1.908 1.241-2.003-4.139-.702-8.248-1.735-11.942-3.808l-.551 7.063c.456.46 10.142-.366 11.252-1.252m3.969-12.613-11.951-3.52-1.639 4.341c4.453 1.218 9.176 4.558 13.882 2.758zm3.792-6.231-.675-4.219c-4.195-1.463-9.398-1.977-13.444-3.661-1.792-.746-3.426-3.272-5.194-1.939-3.21 3.126-1.572 3.448 1.564 5.027 2.285 1.151 16.368 6.162 17.749 4.792m1.081-10.863c-.002-1.259.26-4.226-.899-4.934-.808-.494-6.461-1.451-8.203-1.983-1.805-.552-6.863-3.69-8.007-1.781-.416.868-.444 1.987-.165 2.889.843 2.724 14.212 5.781 17.274 5.809m1.912-21.331c8.044-7.211 13.598-20.644 15.312-31.237 4.693-29.01-16.429-52.88-24.301-79.114-3.15-10.497-6.76-30.103 7.619-33.428-1.473-2.074-4.24-.823-5.932.316-6.128 4.124-6.924 16.488-5.852 23.16 4.088 25.451 23.129 50.212 21.558 77.27-.871 15.011-8.447 26.864-16.269 39.115zm-11.688 7.193 8.689 2.734 1.094-4.882-8.143-3.266zm-8.149-139.56-133.594 58.649c6.191-.007 13.06.939 19.116 2.339 9.48 2.191 18.485 6.418 28.409 7.436 9.604.984 9.186.352 18.009 4.801 13.355 6.735 24.591 14.551 34.951 25.334 8.251 8.587 16.434 20.299 25.505 27.718 3.679 3.009 7.558 3.603 11.405 6.238 3.488-10.977 11.274-19.138 15.223-30.131 4.973-13.845 2.265-27.764-2.037-41.43-6.315-20.06-18.842-39.099-16.987-60.954m-153.075 66.875c-1.402 2.172 1.233 12.996 1.049 15.936-.153 2.427-2.7 5.265-4.903 3.253-2.365-2.16-2.073-13.014-2.74-16.545l-22.805 10.048c3.241 1.242 7.279 3.522 9.796 5.948 4.178 4.026 6.024 10.725 10.016 14.968l17.655 9.539 5.201-2.488c.795-1.268-3.209-4.192-.285-6.765 3.031-2.667 4.741 1.936 6.768 3.504 10.281 7.95 24.081 2.754 35.276 2.156 9.393-.502 9.055 2.833 14.951 7.902 12.54 10.781 32.552 16.329 47.207 26.653 1.796 1.265 11.735 8.858 12.259 10.01.918 2.016-1.633 8.186-1.882 11.13-.298 3.527-.405 8.71 1.177 11.841.32.633 3.537 4.898 3.854 5.107 2.362 1.548 9.725.269 12.334 2.323.19-2.528 1.055-5.002 1.514-7.45.15-.803-.424-1.632-.309-2.473.189-1.393 3.185-6.013 2.565-6.869l-3.081-1.598c-5.423.892-5.074 11.246-11.553 8.89-5.072-2.99 6.516-13.579 8.392-16.059.999-1.321 1.409-3.201 2.465-4.597.598-.79 1.942-1.238 2.069-1.454.411-.702.002-3.553.243-4.923.647-3.673 3.837-5.333 6.39-7.451-5.224-1.675-8.875-3.187-13.041-6.788-8.529-7.37-16.258-18.622-24.153-26.898-10.621-11.135-24.288-20.331-38.092-27.081-6.429-3.143-15.395-2.357-23.021-4.134-15.105-3.519-27.376-8.644-43.713-8.66-4.605-.005-7.48 1.361-11.603 3.025m-30.487 17.854c2.255 1.28 2.253 5.158 3.261 6.237 1.392 1.49 6.788 3.742 8.681 5.163 1.048-1.127-9.159-12.163-11.942-11.4m-.769 15.692c2.111.321 4.608.24 6.743.047l-5.165-3.702-3.522 2.63c-.082.813 1.387.94 1.944 1.025m-3.167-10.676c-1.857-2.349-10.692 8.067-13.157 2.571-2.062-4.596 6.024-6.41 8.961-8.431-.585-8.946-8.786 3.061-11.462-1.154-3.654-5.755 6.932-6.301 6.565-10.764-2.589-1.523-7.707 4.657-10.056 1.898-3.493-4.103 4.963-5.787 2.991-10.324-3.104-1.068-5.584 1.885-7.928 2.163-2.07.246-3.925-.904-5.927-1.07-6.577-.545-11.906 1.342-18.212 2.48l-43.786-31.724c-4.526-2.046-8.587-5.043-13.225-6.869-11.197-4.406-22.096-3.939-33.91-4.597-3.696 1.535-7.435 6.039-7.901 10.02-.714 6.093 3.294 25.005 9.942 27.031 1.631.497 2.267-.234 3.238-.041.863.172 3.536 2.304 4.731 2.892 23.248 11.436 52.718 7.386 75.879 20.792 5.861 3.393 20.025 16.166 25.461 16.912 2.944.403 15.527-2.372 18.69-3.508 2.512-.902 11.829-4.831 9.106-8.277m-117.861-5.695c3.405.508 9.835-1.335 8.74 4.074-1.021 5.047-11.744 1.377-11.863 2.325-1.236 19.991 18.182 29.956 36.071 26.809 8.104-1.425 12.271-6.921 19.498-9.829 3-1.208 13.659-4.987 14.41-.043.678 4.45-10.088 4.455-13.078 6.263l-9.098 5.826c12.767 5.062 22.334 14.258 24.506 28.178 5.23.692 10.822 3.266 13.233 8.214 2.262-2.573 5.501-3.977 8.74-4.855-1.02-4.203 2.464-8.876 5.303-11.787 4.324-4.435 9.285-5.703 14.474-8.622-2.533-4.075-6.306-8.461-8.597-12.573-.818-1.468-2.536-4.01-1.046-5.477.673-.662 2.979-.9 3.879-.609 1.02.331.386 2.029 1.96 1.559l-3.325-7.536c-7.835 1.064-13.284 3.34-20.735-.712-6.742-3.667-12.33-9.227-18.668-13.376-7.882-5.159-19.183-8.486-28.35-10.623-18.365-4.281-38.867-3.306-54.915-14.455 2.553 8.045 10.329 15.979 18.861 17.249m56.919 76.188c-2.897 3.616-.661 9.264-1.406 13.257-.262 1.401-1.7 2.448-2.245 3.729-4.001 9.398-1.693 16.2 3.918 24.001.367.511 1.223.706 1.798 1.494 3.49 4.779 1.401 9.476 9.145 11.435 1.786.452 3.663.125 5.197.776 1.695.72 2.459 3.568 5.015 4.762 1.35.63 5.914 1.844 7.364 1.911 2.503.114 4.167-1.355 5.943-1.392 3.296-.07 8.156 2.714 12.418 2.428 5.714-.383 9.259-4.878 13.355-5.701 4.397-.884 8.426.569 10.094-5.652 2.12-7.906-4.746-6.366-9.12-8.294-2.398-1.057-5.88-4.69-8.917-6.291-1.545-.815-5.028-1.47-5.997-2.421-2.394-2.353.169-9.015-4.109-11.924-2.994-2.036-4.985 1.705-7.532 2.483-6.872 2.099-14.119-2.308-15.542-9.268-1.138-5.57 3.306-15.934-2.092-19.632-.975-.668-6.957-2.436-8.05-2.249-.558.095-8.718 5.9-9.237 6.548m72.434 22.826c-1.671-.373-3.075.825-4.617 1.007-3.443.408-10.839-2.047-8.651-6.477 1.826-3.698 6.602 1.644 10.222-.513.812-.483 5.299-6.311 5.312-7.347l-14.736-33.951c-6.006 2.099-15.512 5.528-18.38 11.728-1.176 2.542-1.445 8.694-2.191 9.758-1.618 2.304-4.073.721-5.77.743-5.148.068-9.034 11.178-8.368 15.475.324 2.096 3.332 5.758 5.614 5.727 3.566-.049 6.603-6.358 12.266-4.044.71.29 5.399 3.732 5.916 4.401 2.081 2.698 2.666 9.605 3.316 10.262.538.542 3.345 1.282 4.531 1.987 3.571 2.122 6.421 5.976 11.018 5.84 2.201-.065 2.596-5.859 3.093-7.689.403-1.484 2.634-6.026 1.425-6.907m3.303-29.37c-.914-2.174-.203-4.587-.649-6.674-.19-.889-1.06-1.492-1.229-2.293-1.313-6.245 3.427-11.756-7.351-10.579-.104 1.031.337 1.927.668 2.859 1.383 3.895 4.612 11.637 6.636 15.088.473.807.713 1.818 1.925 1.599m18.325-41.43c-1.168-.915-11.159-6.556-12.19-6.789-4.706-1.062-11.164.781-16.171.421-4.93-.354-8.127-3.367-12.769-2.161l4.705 10.336c4.093 1.045 9.561-2.74 12.941-2.747 1.79-.004 4.197 1.522 6.226 1.934 6.157 1.25 11.785 1.393 17.944.248.308-1.253-.24-.894-.686-1.242m123.004 44.544c.17-1.097 1.652-2.249.7-3.637-.767-1.682-15.728-11.572-18.378-13.145-15.09-8.957-33.126-13.616-44.868-27.308-9.335.144-18.474 3.311-27.935 2.353-2.474-.25-5.972-1.217-8.498-1.821-2.859-.683-3.675-2.283-7.044-.277l105.354 57.018c-.245-4.308.006-8.912.669-13.183m-136.855-21.928c.862 2.669-.369 5.178-.085 7.087.153 1.031.84 1.824.991 2.826.604 3.998 1.985 7.821.052 11.615 8.115 1.731 5.632 8.997 1.345 13.613l42.644 98.548c.78.771.367-.315.743-.597 6.775-5.094 11.526-8.417 19.527-11.728 15.588-6.45 31.814-7.081 46.813-15.644 21.791-12.439 24.405-34.229 33.912-55.359-3.546-.838-3.946-5.101-7.2-6.667l-114.417-61.017c-2.281-.595-5.582 1.148-8.153 1.659-6.573 1.305-10.752 1.794-17.498.651-2.277-.386-6.153-1.988-7.772-2.059-2.764-.121-7.33 2.994-10.581 2.22l2.804 8.05c6.428-.826 14.493-.57 16.875 6.802m47.124 152.697 1.068-.54c-2.847-9.432 6.487-16.579 14.023-20.218 22.807-11.013 52.762-6.973 72.603-24.069 12.173-10.489 17.846-27.093 21.447-42.311l-8.635-2.728c-5.845 15.895-10.903 33.126-25.063 43.651-20.548 15.272-44.466 13.317-64.858 25.838-5.924 3.637-17.18 13.242-10.585 20.377M-72.431-24.374l-1.701 5.36 8.688 2.721c2.081-6.109-1.634-7.477-6.987-8.081M31.039 29.3l-49.397-10.258c-1.293-.95-1.005-3.118.197-4.083L-6.79 8.694l-52.131-27.703c1.102 3.901-1.479 5.453-2.574 8.017-1.384 3.24-2.012 8.376-3.246 11.961-4.546 13.204-10.089 25.079-20.592 34.538-19.041 17.149-44.954 14.25-67.682 22.739-4.647 1.736-15.211 6.924-16.935 11.791-.24.68.408 4.341.103 6.137-1.391 8.214-11.147 8.438-14.801 1.483-2.422-4.612-1.395-9.919.666-14.471l-42.224-97.943c-2.231 1.282.234 3.473.515 5.187.569 3.477-2.041 11.528-3.071 15.328-.284 1.051-1.651 3.459-1.646 3.659.006.271 2.494 2.874 2.889 4.569 1.563 6.71-2.446 14.906-9.151 16.993-2.428.756-4.466.014-6.506.554-3.487.922-5.409 4.582-11.603 5.234-5.963.627-9.583-1.628-14.056-1.605-4.468.023-6.529 1.723-12.351.447-6.047-1.324-6.389-3.883-10.225-6.067-3.005-1.711-8.282-2.038-11.378-4.916-2.384-2.216-3.168-6.952-4.642-9.478-.812-1.39-3.165-3.436-4.26-4.973-5.595-7.855-5.998-16.72-3.057-25.775.488-1.502 1.805-3.136 2.073-4.443.935-4.549-.688-8.512 1.648-13.56 2.24-4.843 11.336-7.951 11.972-10.336.637-2.383-3.95-10.604-5.616-12.647-3.787-4.646-15.808-11.704-21.788-11.888-2.785-.086-6.81 1.046-9.699 1.065-12.314.078-25.228-6.828-31.339-17.592-3.782-6.661-3.301-11.535-3.257-19.01-8.123-5.357-12.605-10.628-16.21-19.635-.743-1.857-.831-3.922-1.506-5.554-.958-2.313-3.542-5.069-4.726-7.765-4.946-11.248-7.386-29.354 6.035-35.772 4.468-2.136 4.982-1.158 9.143-1.13 9.523.065 18.827.312 27.979 3.228 1.67-8.458 7.677-20.5 7.007-28.982-.065-.815-.313-2.002-.679-3.404l-.001-.002q-.12-.466-.259-.961c-.272-1.309-.427-3.566 1.518-4.214 2.695-.898 4.478 2.275 4.876 3.654.916 3.442 1.255 6.733.424 11.216-1.249 6.738-3.751 14.289-5.655 20.958-.394 1.381-1.858 3.094-.993 4.465 10.816 5.22 20.285 12.531 29.991 19.475 6.337-4.971 13.164-10.717 21.601-11.359 3.06-.232 11.562-.796 12.242 3.036 1.001 5.648-7.295 2.716-10.584 2.967-6.233.477-13.512 4.906-17.646 9.499l17.751 12.665c5.308-.983 11.302-2.496 16.718-2.064 1.738.138 3.917 1.123 5.459 1.09 2.963-.064 6.626-3.321 10.564-1.39 4.764 2.335 2.808 4.986 4.042 6.844.434.653 3.985.271 5.743 2.947 1.593 2.426.578 5.397 2.734 7.865l28.425-12.421c.633-.404.379-1.273.341-1.919-.437-7.486-3.737-19.688-10.699-23.558-3.782-2.103-9.588-1.228-8.074-6.672.917-3.292 6.365-.445 8.445-.76-2.562-9.887-5.403-18.764-10.22-27.797-2.833-5.313-7.745-11.373-9.974-16.639-1.727-4.082-2.109-8.97-3.549-13.287-1.363-4.087-3.884-7.767-5.052-11.784-1.538-5.29-1.516-11.04-3.254-16.313-.073-2.648 2.52-4.167 4.63-2.448 3.038 2.474 3.24 11.742 4.34 15.761 1.282 4.689 4.205 9.062 5.724 13.827 1.214 3.81 1.565 8.455 3.134 12.073 4.32 9.961 11.591 18.094 15.72 29.358 2.503 6.826 3.188 16.128 5.534 21.621.864 2.024 3.167 3.973 4.282 6.037 3.317 6.14 3.413 13.414 5.795 19.714l155.756-67.864c2.056-5.378 7.514-11.618 13.703-11.447 5.573.154 10.364 3.954 8.818 9.948-1.28 4.964-9.305 2.563-10.185 10.448-2.381 21.324 17.126 47.512 23.497 67.747 7.254 23.044 4.627 44.219-9.93 63.673-.921 1.23-2.78 2.354-3.478 3.582-.364.64-2.329 6.747-2.399 7.435-.12 1.186 2.631 4.859 2.571 7.948-.048 2.508-1.991 5.483-2.092 7.144-.114 1.871.842 3.712.391 6.362-.482 2.832-3.051 4.823-3.134 5.13-.387 1.418.26 3.617-.25 5.603-.654 2.552-2.702 2.839-3.27 3.79-.836 1.402-.332 5.904-2.199 7.577l-6.219 3.817L-5.411 2.699c.933.139.832.032.817-.811-.062-3.706-1.056-8.12-1.103-11.912.284-1.6 1.739-2.437 3.245-1.659l35.577 37.215c.846 1.784.039 3.875-2.086 3.768",
    clipPath: "url(#i)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 930.616 523.792)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrion);
export default __webpack_public_path__ + "static/media/ORION.6b2c04f7dc26d6fdd0c5f6b9be98b2fa.svg";
export { ForwardRef as ReactComponent };